import { Routes } from '@angular/router';
import { rolesGuard } from '../../partials/guards/roles.guard';
import { MOCK_NOTICE, mockDataGuard } from './guards/mock-data.guard';

// AMLOfficer case-management module. Mirrors the prototype's internal nav
// (Cases | Dashboard | Signals | VASP | Events) as child routes under one shell.
// Porting status from the prototype — see ./PORTING-CHECKLIST.md
// Read audience. Deliberately wider than the write set (see CASE_WRITE_ROLES): a MANAGER may browse
// cases but every mutating control is hidden from it, and WALLET_STOP_MANAGER — which the API accepts
// on every case and signal write — has to be able to reach the screen at all.
const ACCESS = ['SUPER_USER', 'GENERAL_MANAGER', 'WALLET_STOP_MANAGER', 'MANAGER'] as const;

// The cross-case reads — the signals list, the dashboard and the events feed — are closed to MANAGER:
// a signal row names a case, its reference and its losses, and the events feed has its own
// @AdminAccessExceptManager gate. A MANAGER would get 403 on every call, so the screens are not offered.
const PORTFOLIO_ACCESS = ['SUPER_USER', 'GENERAL_MANAGER', 'WALLET_STOP_MANAGER'] as const;

export const caseManagementRoutes: Routes = [
    {
        path: 'case-management',
        canActivate: [rolesGuard([...ACCESS])],
        loadComponent: () => import('./case-management.component').then(c => c.CaseManagementComponent),
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'cases' },
            {
                path: 'cases',
                loadComponent: () => import('./views/cases/cases.component').then(c => c.CasesComponent),
            },
            {
                path: 'case/:id',
                loadComponent: () => import('./views/case-detail/case-detail.component').then(c => c.CaseDetailComponent),
            },
            {
                path: 'dashboard',
                canActivate: [rolesGuard([...PORTFOLIO_ACCESS])],
                loadComponent: () => import('./views/dashboard/dashboard.component').then(c => c.CaseDashboardComponent),
            },
            {
                path: 'signals',
                canActivate: [rolesGuard([...PORTFOLIO_ACCESS])],
                loadComponent: () => import('./views/signals/signals.component').then(c => c.SignalsComponent),
            },
            // The VASP directory is not in the 6.3 API yet — the screen warns before it opens, so its
            // numbers are not mistaken for production data. See ./guards/mock-data.guard.ts
            {
                path: 'vasp',
                canActivate: [mockDataGuard(MOCK_NOTICE.vasp)],
                loadComponent: () => import('./views/vasp/vasp.component').then(c => c.VaspComponent),
            },
            {
                path: 'events',
                canActivate: [rolesGuard([...PORTFOLIO_ACCESS])],
                loadComponent: () => import('./views/events/events.component').then(c => c.EventsComponent),
            },
            {
                path: 'wallet-by-signal',
                canActivate: [rolesGuard([...PORTFOLIO_ACCESS])],
                loadComponent: () => import('../wallets-by-clusters/wallets-by-clusters.component').then(c => c.WalletsByClustersComponent),
            },
        ],
    },
];
